import { underlyingHistoApiConnector } from 'apiConnector/underlyingHistograph/underlyingHistoApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import type { EpicWithThunk } from 'state/state.common';
import { underlyingHistoFetched, underlyingHistoFetchFailed } from 'state/underlyingHistograph/underlyingHisto.action';
import type { HttpError } from 'utils/http/httpClient.model';
import { isHttpError } from 'utils/http/httpClient.model';

export function fetchUnderlyingHistoEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('UNDERLYING_HISTORICS_REQUESTED'),
      filter(({ bloombergIds }) => bloombergIds.length > 0),
      mergeMap(({ bloombergIds }) =>
        underlyingHistoApiConnector(httpClient)
          .getUnderlyingsHistoByIds(bloombergIds)
          .pipe(
            map(historics => underlyingHistoFetched(historics)),
            catchError((err: HttpError) => {
              if (isHttpError(err)) {
                const statusCode = err.status;
                if (statusCode > 400 && statusCode < 500) {
                  return of(
                    underlyingHistoFetchFailed('underlying-histo-functionalError.content'),
                    showNotificationThunk({
                      level: 'danger',
                      title: { id: 'underlying-histo-functionalError.title' },
                      content: [{ id: 'underlying-histo-functionalError.content' }],
                      closeAutomatically: true,
                      minWidth: 500,
                    }),
                  );
                }
              }
              return of(
                underlyingHistoFetchFailed('technical error'),
                showNotificationThunk({
                  level: 'danger',
                  title: { id: 'underlying-histo-technicalError.title' },
                  content: [{ id: 'underlying-histo-technicalError.content' }],
                  closeAutomatically: true,
                  minWidth: 500,
                }),
              );
            }),
          ),
      ),
    );
}
